import Swal from "sweetalert2";
import api from "./api";
import { PermissoesDto } from "../shared/dtos/Permissoes.dto";


class PermissoesService {
  async getAllPermissoes(): Promise<PermissoesDto[]> {
    return api
      .get("/permissoes/find-all")
      .then((response) => {
        return Promise.resolve(response.data as PermissoesDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar lotações`);
        return Promise.reject(error);
      });
  }


  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const permissoesService = new PermissoesService();
export default permissoesService;
